import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';

import { Typography, IconButton } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { styles } from './styles';

import { CrossIcon, NotificationErrorIcon } from '../Icon';

const useStyles = makeStyles(styles);

const CustomSnackBar = forwardRef(({ id, title, message, type, Icon = null }, ref) => {
  const { closeSnackbar } = useSnackbar();
  const classes = useStyles({ type });

  const handleClose = () => {
    closeSnackbar(id);
  };

  const renderIcon = () => {
    return Icon ? <Icon className={classes.leftIcon} /> : <NotificationErrorIcon className={classes.leftIcon} />;
  };

  return (
    <div className={classes.root} ref={ref}>
      {renderIcon()}
      <div className={classes.content}>
        <Typography component="div" className={classes.title}>
          {title}
        </Typography>
        <Typography component="div">{message}</Typography>
      </div>
      <IconButton className={classes.closeButton} size="small" aria-label="close" onClick={handleClose}>
        <CrossIcon />
      </IconButton>
    </div>
  );
});

CustomSnackBar.displayName = 'CustomSnackBar';

CustomSnackBar.propTypes = {
  id: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default CustomSnackBar;
